import currency from "currency.js";
import { MoneyApi } from "go-core/api/types";
import { OrderData } from "../../../../../../../services/Api/Public/types";

export const getEOrderTotalPriceWithTip = (order: OrderData, search: string): MoneyApi => {
	const urlSearchParams = new URLSearchParams(search);

	const orderPrice = order?.to_pay.amount || 0;
	const tipAmount = Number(urlSearchParams.get("tipAmount"));

	const priceAmount = tipAmount ? currency(orderPrice).add(tipAmount).value : orderPrice;

	return { amount: priceAmount, currency: order.to_pay?.currency };
};
